import React from 'react';
import useTypographyVariants from '../../hooks/useTypographyVariants';
import * as S from './Section.styles';
const Section = ({
  title,
  children,
  extra,
  show = true
}) => {
  const variants = useTypographyVariants();
  if (!show) return null;
  return /*#__PURE__*/React.createElement(S.Root, null, /*#__PURE__*/React.createElement(S.Header, null, /*#__PURE__*/React.createElement(S.Title, {
    variant: variants.subheading
  }, title), extra), /*#__PURE__*/React.createElement(S.Content, null, children));
};
export default Section;